/**
 * @file: enumValueUtil.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  CarwashType,
  OldPartDisposalType,
  OrderReservationType,
  OrderReturnType,
} from '@euler/model/enum';

export function getEnumDisplayText<T extends string | number | symbol>(
  value: T | null | undefined,
  defs: { [p in T]: string },
  defaultText = '无',
) {
  if (value == null) return defaultText;
  return defs[value];
}

export function formatCarwashType(
  value: CarwashType | null | undefined,
  fallbackText?: string,
) {
  return getEnumDisplayText(
    value,
    {
      [CarwashType.None]: '无',
      [CarwashType.NoWash]: '不洗车',
      [CarwashType.FreeWash]: '免费洗车',
      [CarwashType.PaidWash]: '自费洗车',
    },
    fallbackText,
  );
}

export function formatReservationType(
  value: OrderReservationType | null | undefined,
  fallbackText?: string,
) {
  return getEnumDisplayText(
    value,
    {
      [OrderReservationType.None]: '无',
      [OrderReservationType.NonReserved]: '未预约',
      [OrderReservationType.Reserved]: '预约服务',
    },
    fallbackText,
  );
}

export function formatOldPartDisposableType(
  value: OldPartDisposalType | null | undefined,
  fallbackText?: string,
) {
  return getEnumDisplayText(
    value,
    {
      [OldPartDisposalType.None]: '无',
      [OldPartDisposalType.Keep]: '需保留',
      [OldPartDisposalType.KeepForLook]: '需查看',
    },
    fallbackText,
  );
}

export function formatReturnType(
  value: OrderReturnType | null | undefined,
  fallbackText?: string,
) {
  return getEnumDisplayText(
    value,
    {
      [OrderReturnType.None]: '不需要',
      [OrderReturnType.Deliver]: '需要送车',
      [OrderReturnType.Pick]: '客户自取',
      [OrderReturnType.OnSite]: '在厂等待',
    },
    fallbackText ?? '不需要',
  );
}
